import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import App from './App'
import theme from './theme'
import './index.css'
import ErrorBoundary from './components/ErrorBoundary';
import * as Sentry from '@sentry/react';

if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.MODE, // 'development' | 'production'
        tracesSampleRate: 0.1,
        integrations: [
            Sentry.browserTracingIntegration(),
            // Session Replay — records a video-like replay of user sessions where errors occur.
            // Privacy: text content is masked by default (replaysOnErrorSampleRate only).
            Sentry.replayIntegration({
                maskAllText: true,       // hide all text in replays (good for sensitive admin data)
                blockAllMedia: false,
            }),
        ],
        // Capture replays only when an error occurs — not on every session
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
        // Ignore noisy browser extension / network errors
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'Network Error',
            'Failed to fetch',
        ],
    });
}
ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </ThemeProvider>
    </React.StrictMode>,
)
